import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
// Updated key to force refresh
root.render(
  <React.StrictMode>
    <App key="v-final-clean-team-v2" />
  </React.StrictMode>
);